import { useCallback, useEffect, useState } from 'react';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import UsMarket from '@/creditflowresearch/domain/Market/entities/UsMarket';
import IgcProduct from '@/creditflowresearch/domain/Product/entities/IgcProduct';

const useIncludeNonCountablesFilter = () => {
  const { getDraft, setLocalFilters, subscribe } = useCorporateBondScreenerSidebarFilterContext();

  const buildState = useCallback(() => {
    const draft = getDraft();
    const isUsIgSelected = draft.includedMarketIds.includes(UsMarket.MARKET_ID)
      && draft.includedProductIds.includes(IgcProduct.PRODUCT_ID);
    return { isUsIgSelected, checked: isUsIgSelected && draft.includeUsIgNonCountables !== false };
  }, [getDraft]);

  const [{ isUsIgSelected, checked }, setState] = useState(buildState);
  const [wasUsIgSelected, setWasUsIgSelected] = useState(isUsIgSelected);

  useEffect(() => {
    const sync = (): void => setState(buildState());
    sync();
    return subscribe(sync);
  }, [buildState, subscribe]);

  useEffect(() => {
    if (!isUsIgSelected && getDraft().includeUsIgNonCountables === true) {
      setLocalFilters((prev) => ({ ...prev, includeUsIgNonCountables: false }));
    }

    if (isUsIgSelected && !wasUsIgSelected && getDraft().includeUsIgNonCountables === false) {
      setLocalFilters((prev) => ({ ...prev, includeUsIgNonCountables: true }));
    }

    setWasUsIgSelected(isUsIgSelected);
  }, [isUsIgSelected, wasUsIgSelected, getDraft, setLocalFilters]);

  const onChange = useCallback(() => {
    setLocalFilters((prev) => ({ ...prev, includeUsIgNonCountables: prev.includeUsIgNonCountables === false }));
  }, [setLocalFilters]);

  return { checked, disabled: !isUsIgSelected, onChange };
};

export default useIncludeNonCountablesFilter;
